import * as React from 'react';
import * as main from '../../main.module.scss';
import * as res from './style.module.scss';
export const ResultsStudents = () => {
  return (
    <section className={res.res}>
      <div className="container">
        <h2 className={main.title}>Результаты выпускников Advance</h2>
        <p className={main.subtitle}>Это делают обычные люди без сверхспособностей после обучения</p>
        <a href="#regForm" aria-label={'regForm'}>
          <ul className={res.numsList}>
            <li>
              <h3>
                <span>100</span> слов
              </h3>
              <p>Запоминают ученики Advance за один час</p>
            </li>
            <li>
              <h3>
                <span>5</span> дней
              </h3>
              <p>для прохождения вузовского учебника</p>
            </li>
            <li>
              <h3>
                <span>3</span> месяца
              </h3>
              <p>для базового освоения новой профессии</p>
            </li>
            <li>
              <h3>
                <span>1</span> вечер
              </h3>
              <p>для прочтения нехудожественной книги</p>
            </li>
            <li>
              <h3>
                в <span>3</span> раза
              </h3>
              <p>быстрее запоминают сложные темы и удерживают их в памяти надолго</p>
            </li>
            <li>
              <h3>
                в <span>2</span> раза
              </h3>
              <p>быстрее читают и воспринимают информацию с полным пониманием</p>
            </li>
            <li>
              <h3>
                <span>150</span> часов в год
              </h3>
              <p>
                столько вы получите дополнительного свободного времени, которое раньше уходило на запоминание,
                перечитывание и т.д
              </p>
            </li>
            <li>
              <h3>
                в <span>2</span> раза лучше
              </h3>
              <p>будете запоминать информацию</p>
            </li>
          </ul>
        </a>
      </div>
    </section>
  );
};
